// Next-step suggestions ("Do I need a licence for Spain?") stay on the message that offered them.
// Once the user has clicked one, it has been answered, so it should stop being offered — on that
// message and on every earlier one that carried the same suggestion. A click sends the suggestion's
// own prompt as the user's message, so "answered" means a later user message equals that prompt.
interface NextStepLike {
  prompt: string;
}

const normalise = (text: string): string => (text || '').trim().toLowerCase();

export const unansweredNextSteps = <T extends NextStepLike>(
  steps: T[] | undefined,
  laterUserTexts: string[],
): T[] => {
  if (!steps || steps.length === 0) return [];
  const answered = new Set(laterUserTexts.map(normalise));
  return steps.filter((step) => !answered.has(normalise(step.prompt)));
};
